const addMemberWidget = {
  openButton: "Add member",
  pendingInvitations_one: "{{count}} pending invitation",
  pendingInvitations_other: "{{count}} pending invitations",
  heading: "Add Member to Project",
  searchPlaceholder: "Type a name or email address...",
  clearButton: "Clear",
  noMatches: {
    alreadyMember: "This user is already a member of this project",
    noneAvailable: "No matching users available to add",
    typeFullEmail: "No matching users found — type a full email to send an invitation",
    noneFound: "No matching users found",
  },
  notInOrgText: "is not in your organization",
  clickToInvite: "— click to send invitation",
  roleLabel: "Role:",
  roleResearcher: "Researcher",
  rolePi: "PI (Principal Investigator)",
  expiryLabel: "Expires in:",
  expiryOptions: {
    hours24: "24 hours (1 day)",
    hours72: "72 hours (3 days)",
    hours168: "168 hours (7 days)",
    hours336: "336 hours (14 days)",
    hours720: "720 hours (30 days)",
  },
  addButton: "Add to Project",
  adding: "Adding...",
  sendButton: "Send Invitation",
  sending: "Sending...",
  pendingInvitationsHeading: "Pending Invitations",
  openInvite: "Open invite",
  expiresOn: "expires {{date}}",
  revokeButton: "Revoke",
  revokeConfirm: "Revoke this invitation?",
  loadingInvitations: "Loading invitations...",
  inviteLinkShownOnce: "Invite link (shown once)",
  dismissButton: "Dismiss",
  messages: {
    assignSuccess: "{{name}} added to project as {{role}}.",
    assignError: "Failed to add user.",
    inviteSuccess: "Invitation created for {{email}}. Copy the link now — it cannot be shown again.",
    inviteError: "Failed to send invitation.",
    revokeError: "Failed to revoke invitation.",
    linkCopied: "Invitation link copied!",
  },
};

export default addMemberWidget;
